import React from 'react'
import { Typography, Input, Row, Col, Form, Collapse, Space, Button } from 'antd'
import PropTypes from 'prop-types'
import { ImageUploader } from '~components'
import styles from './ContentCard.module.css'

const { Title } = Typography
const { TextArea } = Input
const { Panel } = Collapse

const ContentCard = ({ contentCard, setContentCard }) => {
  const deleteContentCard = (event, index) => {
    event.stopPropagation()
    const clonedContentCard = [...contentCard]
    if (index !== -1) {
      clonedContentCard.splice(index, 1)
    }
    setContentCard(clonedContentCard)
  }

  const handleHeaderChange = ({ target }, index) => {
    const clonedContentCard = [...contentCard]
    clonedContentCard[index] = {
      ...clonedContentCard[index],
      title: target.value
    }
    setContentCard([...clonedContentCard])
  }
  const handleSubtitleChange = ({ target }, index) => {
    const clonedContentCard = [...contentCard]
    clonedContentCard[index] = {
      ...clonedContentCard[index],
      subtitle: target.value
    }
    setContentCard([...clonedContentCard])
  }

  const handleIconChange = (imgObj, rowIndex) => {
    const clonedContentCard = [...contentCard]
    clonedContentCard[rowIndex] = {
      ...clonedContentCard[rowIndex],
      image: imgObj
    }
    setContentCard([...clonedContentCard])
  }
  const handleIconUrlChange = (secureImageURL, rowIndex) => {
    const clonedContentCard = [...contentCard]
    clonedContentCard[rowIndex] = {
      ...clonedContentCard[rowIndex],
      image: { ...clonedContentCard[rowIndex].image, url: secureImageURL }
    }
    setContentCard([...clonedContentCard])
  }

  const handleCTANameChange = (event, index) => {
    const clonedContentCard = [...contentCard]
    clonedContentCard[index] = {
      ...clonedContentCard[index],
      cta: { ...clonedContentCard[index].cta, name: event.target.value }
    }
    setContentCard([...clonedContentCard])
  }
  const handleCTAUrlChange = (event, index) => {
    const clonedContentCard = [...contentCard]
    clonedContentCard[index] = {
      ...clonedContentCard[index],
      cta: { ...clonedContentCard[index].cta, url: event.target.value }
    }
    setContentCard([...clonedContentCard])
  }
  return (
    <div className={styles['content-card-container']}>
      <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right' style={{ width: '100%' }}>
        {contentCard?.map((card, rowIndex) => (<Panel key={rowIndex}
          extra={<Row gutter={2}><Space>
            <Button danger onClick={(event) => deleteContentCard(event, rowIndex)} style={{ backgroundColor: '#DA0D50', color: '#fff' }}>Delete</Button>
          </Space>
          </Row>
          }
          header={<span style={{ fontSize: 20 }}>{card?.title}</span>}>
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Content Card Header*</Title></Col>
          </Row>
          <Row>
            <TextArea
              autoSize={{ minRows: 2 }}
              maxLength={155}
              onChange={(e) => handleHeaderChange(e, rowIndex)}
              style={{ width: '100%' }}
              value={card?.title}
            />
          </Row>
          {card && !card.title && <Typography.Paragraph className={styles['paragraph-text']}>Please fill out this field</Typography.Paragraph>}
          <br />
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Content Card Paragraph Text</Title></Col>
          </Row>
          <Row>
            <TextArea
              autoSize={{ minRows: 2 }}
              maxLength={155}
              onChange={(e) => handleSubtitleChange(e, rowIndex)}
              style={{ width: '100%' }}
              value={card?.subtitle}
            />
          </Row>
          <br />
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Call-to-Action Label*</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item><Input onChange={(event) => handleCTANameChange(event, rowIndex)} value={card.cta?.name}/></Form.Item>
            </Col>
          </Row>
          {card && card.cta && !card.cta.name && <Typography.Paragraph className={styles['paragraph-text']}>Please fill out this field</Typography.Paragraph>}
          <br />
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Call-to-Action URL*</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item><Input onChange={(event) => handleCTAUrlChange(event, rowIndex)} value={card.cta?.url}/></Form.Item>
            </Col>
          </Row>
          {card && card.cta && !card.cta.url && <Typography.Paragraph className={styles['paragraph-text']}>Please fill out this field</Typography.Paragraph>}
          <Row align={'left'} className={styles['title-wrapper']} gutter={[10, 10]}>
            <Col><Title level={3}>Content Card Image</Title></Col>
            <Col><Title level={4}> (Upload PNG or JPG; preferred dimensions 0px x 0px; max file size 1MB)</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <ImageUploader alt={card?.image?.alt} handleIconChange ={(imageObj) => handleIconChange(imageObj, rowIndex)} handleUpload={(imageUrl) => handleIconUrlChange(imageUrl, rowIndex)} logoUrl={card?.image?.url} />
            </Col>
          </Row>
          <br />
        </Panel>))
        }
      </Collapse>
    </div>
  )
}

ContentCard.propTypes = {
  contentCard: PropTypes.array,
  deleteContentCard: PropTypes.func,
  setContentCard: PropTypes.func
}

export default ContentCard
